import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import closeImg from '../../Images/close.svg';
import cellcomLogo from '../../Images/cellcomLogo.svg';
import './IdStage.scss';
import TextInput from 'app/Components/Shared/TextInput/TextInput';

export default function IdStageUI({
  idLabel = 'מספר ת.ז / ח.פ',
  title = 'ת.ז ומתקדמים',
  idValue = '',
  onIdChange,
  onSubmit,
  loading = false,
  error = '',
}) {
  return (
    <form className='id-stage-wrapper' onSubmit={onSubmit}>
      <div className='top-content'>
        <div className='logo-container'>
          <Image src={cellcomLogo} className='logo' alt='logo' />
        </div>
        <span className='title'>{title}</span>
        <TextInput
          className='input'
          name={'login-id-input'}
          type='number'
          pattern='[0-9]*'
          id={'login-id-input'}
          maxLength='9'
          autoComplete='off'
          placeholder={idLabel}
          required='required'
          value={idValue}
          error={error}
          onChange={(e) => onIdChange && onIdChange(e.target.value)}
          disabled={loading}
        />
      </div>
      <button className={'submit-button' + (loading ? ' submit-button--disabled' : '')} type='submit' disabled={loading}>
        <span className='submit-button-text'>{loading ? 'טוען...' : 'המשך'}</span>
      </button>
    </form>
  );
}
